import { Category } from "./CategoryFilter";

/**
 * Generates the full list of category values (parent + all children with prefix)
 */
export const getCategoryWithSubcategories = (category: Category): string[] => {
    return [
        category.name,
        ...category.subcategories.map(subcat => `${category.name};${subcat}`)
    ];
};

/**
 * Calculates the selection state of a category based on its subcategories
 */
export const calculateCategoryState = (
    category: Category,
    selectedCategories: string[]
): {
    isCategoryChecked: boolean;
    selectedCount: number;
    isAllSelected: boolean;
    isPartiallySelected: boolean;
} => {
    const isCategoryChecked = selectedCategories.includes(category.name);
    const selectedCount = category.subcategories.filter(subcat =>
        selectedCategories.includes(`${category.name};${subcat}`)
    ).length;
    const isAllSelected = isCategoryChecked && selectedCount === category.subcategories.length;
    const isPartiallySelected = selectedCount > 0 && selectedCount < category.subcategories.length;

    return {
        isCategoryChecked,
        selectedCount,
        isAllSelected,
        isPartiallySelected
    };
};

/**
 * Determines which categories to toggle when a subcategory is selected/deselected
 */
export const determineSubcategoryToggle = (
    subcategoryValue: string,
    category: Category,
    selectedCategories: string[]
): string[] => {
    const isCurrentlyChecked = selectedCategories.includes(subcategoryValue);
    const allSubcategoriesWithPrefix = category.subcategories.map(s => `${category.name};${s}`);
    const currentlySelectedSubcats = allSubcategoriesWithPrefix.filter(s =>
        selectedCategories.includes(s)
    );

    // If checking this subcategory and it will result in all being checked, also check parent
    if (!isCurrentlyChecked && currentlySelectedSubcats.length === category.subcategories.length - 1) {
        return [subcategoryValue, category.name];
    }

    // Unchecking a subcategory when parent is checked, also uncheck parent
    if (isCurrentlyChecked && selectedCategories.includes(category.name)) {
        return [subcategoryValue, category.name];
    }

    return [subcategoryValue];
};
